// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"93ec4a21","13":"54cd53d2","147":"22a29a7f","453":"28984cf2","749":"1152d8cf","900":"87c38da9","928":"41a84aba","958":"71290a5e"}[chunkId] + ".chunk.js";
};